<template>
  <div class="wrapper">
    <span class="w-title">{{ adding?'新建合同信息':(editing ? "修改合同信息" : "合同详情信息") }}</span>
    <v-divider class="my-3"/>

    <v-container fluid grid-list-md class="xn-form pa-0">
      <div class="detail-btns">
        <v-btn color="info" flat @click="cancel">&lt; 返回合同列表</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="!adding" color="error" flat outline @click="deleteThisItem">删除</v-btn>
        <v-btn v-if="detailing" color="info" flat class="btn-to-edit" @click="toEdit">去编辑 &gt;</v-btn>
      </div>
      <ContractInnerForm
        ref="contractForm"
        :adding="adding"
        :editing="editing"
        :detailing="detailing"
        :show-btn-close="false"
        :binding-company-name="''"
      />
    </v-container>

    <v-container fluid grid-list-md class="pa-0 my-5">
      <v-layout>
        <v-flex xs3 md4></v-flex>
        <v-flex xs6 md4 style="display:flex;justify-content: space-around">
          <v-btn outline @click="cancel">返回</v-btn>
          <v-btn v-if="!detailing" color="info" @click="save">保存</v-btn>
        </v-flex>
        <v-flex xs3 md4></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import ContractInnerForm from "./ContractInnerForm";
  import axios from "../axios";
  import {EventBus} from "../event";
  import {mapState, mapActions} from 'vuex';

  export default {
    name: "ContractForm",
    components: {
      ContractInnerForm,
    },
    watch:{
      id(){
        //点击notification需要监听id变化，要不数据不会刷新
        this.getDetail();
      }
    },
    computed: {
      ...mapState({
        showLoading: state => state.showLoading,
      }),
      id() {
        //console.log(this.$route.params.contractId);
        return this.$route.params.contractId;
      },
      companyId(){
        return this.$route.query.companyId;
      },
      adding() {
        return !this.$route.params.contractId;
      },
      editing() {
        return (!!this.id) && this.$route.name === "contract-form-edit"
      },
      detailing() {
        return (!!this.id) && this.$route.name === "contract-form-detail"
      },
    },
    data: () => {
      return {
        item: {}
      };
    },
    methods: {
      ...mapActions(["setLoading"]),
      cancel() {
        //this.$router.push({name: 'contracts'});
        window.history.back();
      },
      toEdit() {
        this.$router.push("edit");
      },
      deleteThisItem() {
        this.$confirm("确定删除?").then(
          res => {
            if (res) {
              let arr = [];
              arr.push(this.$route.params.contractId);
              this.setLoading(true);
              axios
                .post("/contracts/delete", {
                  contractIds: arr
                })
                .then(() => {
                  this.setLoading(false);

                  this.$confirm("删除成功", {buttonFalseText: null}).then(() => {
                      this.cancel();
                    }
                  );
                })
                .catch(reason => {
                  this.$confirm(reason.response.data.message, {
                    buttonFalseText: null
                  });
                  this.setLoading(false);
                });
            }
          }
        );
      },
      save() {
        let $form = this.$refs.contractForm;
        $form.validate();
        if (!$form.hasErrors) {
          $form.save((res) => {
            this.cancel();
          });
        }
      },
      getDetail() {
        this.setLoading(true);
        axios.get("/contracts/" + this.$route.params.contractId).then(res => {
          //this.item = res.data;
          this.setLoading(false);

          //很奇怪，必须要做一下延迟才能赋值item
          let int = null;
          int = setInterval(() => {
            if (this.$refs.contractForm) {

              this.$refs.contractForm.item = res.data;
              if (this.detailing) {
                this.$refs.contractForm.$refs.reminderTable.isLoading = false;
              }
              clearInterval(int);
            }

          }, 100);
        })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
            this.setLoading(false);
          });
      }
    },
    created() {
      EventBus.$on('reloadReminder', () => {
        this.$refs.contractForm.$refs.reminderTable.isLoading = true;
        this.getDetail();
      });
      if (this.editing || this.detailing) {
        this.getDetail();
      }

    }
  };
</script>

<style scoped></style>

